// Drops keys whose value is undefined, so an explicit `{duration: undefined}` never overrides a default
export function omitUndefinedFields<T extends object>(value: T): T {
  return Object.fromEntries(Object.entries(value).filter(([, entryValue]) => entryValue !== undefined)) as T
}
